import { logException } from '@atlassian/conversation-assistant-instrumentation/services/sentry';

export const reportUnexpectedDismissState = ({
	functionName,
	kind,
}: {
	functionName: string;
	kind: string | undefined;
}): void => {
	void logException({
		exception: new Error('Unexpected ghost icons dismiss state kind'),
		name: 'ghost-icons-dismiss-state-unexpected-kind',
		tags: {
			source: 'ghost-icons-dismiss-state',
			functionName,
			kind,
		},
	});
};
